document.addEventListener("DOMContentLoaded", function () {
  var $TempContainer = $("<div></div>");
  var $ProductList = $(".product-container .grid-downloadss");

  $ProductList.each(function () {
    $TempContainer.append($(this).clone(true, true));
  });

  $(".manual-container .box-alldownload").html($TempContainer.html());
  $(".product-container .box-alldownload").empty();

  var $selectType = $("#se-pro-type");
  var $ManualProducts = $(".manual-container .grid-downloadss");
  var openCard = null;
  var openOverlay = null;

  function setOverlayOpenState(card, overlay, isOpen) {
    if (!card || !overlay) return;
    overlay.setAttribute("aria-hidden", isOpen ? "false" : "true");
    card.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function dismissOverlay(card, returnFocus) {
    if (!card) return;

    var overlay = card.querySelector(".down-load-over");
    if (overlay) {
      overlay.classList.remove("active");
    }
    setOverlayOpenState(card, overlay, false);
    card.classList.add("is-dismissed");

    if (openCard === card) {
      openCard = null;
      openOverlay = null;
    }

    if (returnFocus) {
      card.focus();
    }
  }

  function closeOverlay(returnFocus) {
    var card = openCard;
    if (!card) return;
    dismissOverlay(card, returnFocus);
  }

  function openOverlayForCard(card) {
    if (!card) return;

    var overlay = card.querySelector(".down-load-over");
    if (!overlay) return;

    if (openOverlay && openOverlay !== overlay) {
      closeOverlay(false);
    }

    card.classList.remove("is-dismissed");
    openCard = card;
    openOverlay = overlay;
    overlay.classList.add("active");
    setOverlayOpenState(card, overlay, true);

    var focusTarget =
      overlay.querySelector(".down-load-box a[href]") ||
      overlay.querySelector(".close-down-btn") ||
      overlay;

    if (focusTarget && typeof focusTarget.focus === "function") {
      focusTarget.focus();
    }
  }

  function syncAriaForCard(card) {
    var overlay = card.querySelector(".down-load-over");
    if (!overlay) return;

    if (card.classList.contains("is-dismissed")) {
      setOverlayOpenState(card, overlay, false);
      return;
    }

    var isOpen =
      card.contains(document.activeElement) || overlay.classList.contains("active");
    setOverlayOpenState(card, overlay, isOpen);
  }

  function resolveOpenCard() {
    var activeEl = document.activeElement;
    if (activeEl) {
      var focusedCard = activeEl.closest(".manual-container .grid-downloadss");
      if (focusedCard) return focusedCard;
    }

    if (openCard) return openCard;

    var activeOverlay = document.querySelector(
      ".manual-container .down-load-over.active"
    );
    if (activeOverlay) {
      return activeOverlay.closest(".grid-downloadss");
    }

    return null;
  }

  $selectType.change(function () {
    const type = $(this).val();
    if (type == "all") {
      $ManualProducts.show();
    } else {
      const $TypeProducts = $ManualProducts.filter(`[data-value="${type}"]`);
      $ManualProducts.hide().filter($TypeProducts).show();
    }

    SearchResult();
    SearchText();
  });

  var $SearchInput = $("#dowload_search input");
  var $SearchBtn = $(".bt_manual");
  var $NotSearch = $(".not-search");

  function SearchResult() {
    var result = $SearchInput.val().toLowerCase();
    var type = $selectType.val();

    if (type == "all") {
      var $ShowProduct = $ManualProducts;
    } else {
      var $ShowProduct = $(
        `.manual-container .grid-downloadss[data-value="${type}"]`
      );
    }

    $ShowProduct.each(function () {
      var $this = $(this);
      var title = $this.find(".download_media_title").text().toLowerCase();

      if (title.includes(result)) {
        $this.show();
      } else {
        $this.hide();
      }
    });
  }

  function SearchText() {
    var allHidden = true;
    $ManualProducts.each(function () {
      var $this = $(this);
      if ($this.css("display") !== "none") {
        allHidden = false;
        return false;
      }
    });

    if (allHidden) {
      $NotSearch.show();
    } else {
      $NotSearch.hide();
    }
  }

  $SearchBtn.click(function () {
    SearchResult();
    SearchText();
  });

  $SearchInput.on("keydown", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      SearchResult();
      SearchText();
    }
  });

  $ManualProducts.on("focusin", function () {
    syncAriaForCard(this);
  });

  $ManualProducts.on("focusout", function () {
    var card = this;
    var overlay = card.querySelector(".down-load-over");

    // Wait for the next focus target to settle
    setTimeout(function () {
      if (card.contains(document.activeElement)) {
        syncAriaForCard(card);
        return;
      }

      card.classList.remove("is-dismissed");

      if (overlay && overlay.classList.contains("active")) {
        overlay.classList.remove("active");
      }
      setOverlayOpenState(card, overlay, false);

      if (openCard === card) {
        openCard = null;
        openOverlay = null;
      }
    }, 0);
  });

  $ManualProducts.on("click", function (event) {
    var card = this;
    var target = event.target;

    if (target.closest(".download_media_title-link")) {
      return;
    }

    if (target.closest(".close-down-btn")) {
      event.preventDefault();
      event.stopPropagation();
      dismissOverlay(card, true);
      return;
    }

    if (target.closest(".down-load-box a")) {
      return;
    }

    // Mobile backdrop: click outside container closes
    if (
      target.classList.contains("down-load-over") &&
      (card.querySelector(".down-load-over") === openOverlay ||
        card.contains(document.activeElement))
    ) {
      dismissOverlay(card, true);
      return;
    }

    if (target.closest(".down-load-over.active")) {
      return;
    }

    openOverlayForCard(card);
  });

  $ManualProducts.on("keydown", function (event) {
    if (event.target !== this) return;

    var key = event.key || event.code;
    if (key === "Enter" || key === " " || key === "Spacebar" || key === "Space") {
      event.preventDefault();
      openOverlayForCard(this);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" && event.keyCode !== 27) return;

    var card = resolveOpenCard();
    if (!card || card.classList.contains("is-dismissed")) return;

    var overlay = card.querySelector(".down-load-over");
    var hasFocusInside = card.contains(document.activeElement);
    var isActive = overlay && overlay.classList.contains("active");

    if (!hasFocusInside && !isActive) return;

    event.preventDefault();
    dismissOverlay(card, true);
  });
});
